import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '../constants/endpoint.constants';
import { HttpProService } from './base/http-pro.service';

@Injectable({
    providedIn: 'root',
})
export class ObAgencyService {
    constructor(private httpService: HttpProService) {}

    public getCountPerStatus(): Observable<any> {
        const url = ENDPOINTS.OB_AGENCY.GET_COUNT_PER_STATUS;
        return this.httpService.get(url, true);
    }
}
